"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroTextSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `IntroText`.
 */
const IntroTextSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.INTRO_TEXT_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
      variant: "rectangular",
      animation: animation
    })
  });
};
exports.IntroTextSkeleton = IntroTextSkeleton;
//# sourceMappingURL=IntroTextSkeleton.js.map